const englishFilterOnKeyPress = (e: any) => {
    const charCode = e.charCode
    const value = String.fromCharCode(charCode)
    if (!/^[a-zA-Z 0-9]|_+$/.test(value)) {
        e.preventDefault()
        return false
    } else
        return true
}
export default englishFilterOnKeyPress